import { IUpdateClienteArquivoUseCase } from "../../../presentation/useCases/update/update_cliente_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateClienteArquivoUseCase
 */

export class UpdateClienteArquivoUseCase implements IUpdateClienteArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idClienteArquivo: number,
    idCliente?: number,
    descricao?: string,
    arquivo?: File,
    limparArquivo?: boolean): Promise<void> {
    const computedArquivoNome = limparArquivo ? undefined : arquivo?.name;
    const computedArquivo = limparArquivo ? undefined : arquivo;

    await this.repository.updateClienteArquivo(
      idClienteArquivo,
      idCliente,
      computedArquivoNome,
      descricao,
      computedArquivo,
      limparArquivo
    );
  }

}
